module.exports = __webpack_public_path__ + "img/digitalticket_teiki.5eab14ae.svg";